export default __webpack_public_path__ + "media/images/mailer-new/welcome/step3-off-5a10d6517f8cf75a0c3bdb8835358b79.png";